module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd.fbb1aa81.otf";